import './GapSection.scss'

const CONTROLLED_AREAS = ['finance', 'compliance', 'safety', 'capital']

const GapSection = () => (
  <section className="lnn-section lnn-gapSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-gapSection__head">
        <h2>The Gap</h2>
      </div>

      <div className="lnn-gapSection__layout">
        <div className="lnn-gapSection__control">
          <h3>Organizations control:</h3>

          <ul>
            {CONTROLLED_AREAS.map((area) => (
              <li key={area}>{area}</li>
            ))}
          </ul>
        </div>

        <div className="lnn-gapSection__divider" />

        <div className="lnn-gapSection__gap">
          <h3>They do not control interpretation.</h3>
          <p>So decisions are executed without verifying how they will be acted on.</p>
          <p>That is the gap.</p>
        </div>
      </div>
    </div>
  </section>
)

export default GapSection
